import { MenuItem, Select } from "@material-ui/core";
import React from "react";
import { useDispatch } from "react-redux";
import { useStore } from "../../hooks/useStore";
import { selectCamera } from "../../redux/actions/types/cameraTypes";

const SelectCamera = () => {
  const { cameraStore } = useStore();
  const dispatch = useDispatch();

  const handleSelectedDevice = (event: any) => {
    const device = cameraStore.cameras.find(
      (item) => item.deviceId === event.target.value
    );
    if (device) dispatch(selectCamera(device));
  };

  return (
    <Select
      labelId="demo-simple-select-label"
      id="demo-simple-select"
      style={{ minWidth: 300 }}
      value={cameraStore.deviceId}
      onChange={handleSelectedDevice}
    >
      {cameraStore.cameras.map((item, index) => (
        <MenuItem key={index} value={item.deviceId}>
          {item.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default SelectCamera;
